import SuggestedPostCard from './SuggestedPostCard';
export default SuggestedPostCard;
